import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveEnd, Router} from "@angular/router";
import {RouteData} from "./route-data";
import {Utils} from "../../utils/utils";
import {filter} from "rxjs/operators";

@Injectable()
export class RouteDataService {

  private _routeDatas: RouteData[];
  private _previousRouteDatas: RouteData[];

  constructor(
    private _router: Router
  ) {
    this._routeDatas = [];
    this._previousRouteDatas = [];

    this._router.events
      .pipe(filter((event: any) => event instanceof ResolveEnd))
      .subscribe((event: ResolveEnd): void => {
        this._previousRouteDatas = this._routeDatas;
        this._routeDatas = this.parseRouteDatas(event.state.root);
      });
  }

  private parseRouteDatas(routeSnapshot: ActivatedRouteSnapshot): RouteData[] {
    const routeDatas: RouteData[] = [];
    let routeData: RouteData;
    const queryParams = routeSnapshot.firstChild.params;

    while (routeSnapshot.firstChild) {
      routeSnapshot = routeSnapshot.firstChild;
      const url: string = Utils.getUrlFromRouteSnapshot(routeSnapshot);
      routeData = new RouteData(routeSnapshot.data, url, queryParams, true);
      if (routeDatas[routeDatas.length - 1] && routeDatas[routeDatas.length - 1].url === routeData.url) {
        routeDatas.pop();
      }

      routeDatas.push(routeData);
    }

    return routeDatas;
  }

  public getRouteDatas(): RouteData[] {
    return this._routeDatas;
  }

  public getCurrentRouteData(): RouteData {
    if (!this._routeDatas.length) {
      return null;
    }

    return this._routeDatas[this._routeDatas.length - 1];
  }

  public getPreviousRouteData(): RouteData {
    if (!this._previousRouteDatas.length) {
      return null;
    }

    return this._previousRouteDatas[this._previousRouteDatas.length - 1];
  }

  public getRouteDataByRoute(root: ActivatedRouteSnapshot): RouteData {
    const routeDatas: RouteData[] = this.parseRouteDatas(root);
    return routeDatas && routeDatas.length ? routeDatas[routeDatas.length - 1] : null;
  }

}
